import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  RadioGroupProps
} from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props extends RadioGroupProps {}

const TimeRestrictionValueTypeRadio = React.forwardRef((props: Props, ref) => {
  const { t } = useTranslation()

  return (
    <FormControl>
      <RadioGroup row ref={ref} {...props}>
        <FormControlLabel
          labelPlacement='start'
          value='days'
          label={t('labels.Days')}
          control={<Radio />}
        />
        <FormControlLabel
          labelPlacement='start'
          value='hours'
          label={t('labels.Hours')}
          control={<Radio />}
        />
      </RadioGroup>
    </FormControl>
  )
})
export default TimeRestrictionValueTypeRadio
